



$(document).ready(function() {

  
console.log("dsadsadsadsa");
  

  
  var targetElement = $("section#shopify-section-template--18990961721657__4e5e4f57-29f3-48b5-bdfb-a8b97a345bb5 p");
  var searchText = "google reviews";
  var replaceHtml = '<img class="greviewimg" src="https://cdn.shopify.com/s/files/1/0762/2433/2089/files/download.png?v=1684334426">';
  
  targetElement.each(function() {
    if ($(this).text().trim() === searchText) {
      $(this).replaceWith(replaceHtml);
    }
  });



  
});
